import React, { useEffect } from 'react';

import { useDispatch } from 'react-redux';
import { compose } from 'redux';
import { fetchDetalizationPersonalData } from './store/personalDataStore/actions';
import { fetchRegularDetalizationReportData } from './store/regularDetalizationReport/actions';

// Container
import PrepaidDetalization from './containers/PrepaidDetalization';

// Styles
// Modals
import { DetalizationReportModal } from './components/DetalizationReportModal';
import { RegularDetalizationReportModal } from './components/RegularDetalizationReportModal';
import { EmailModal } from './components/EmailModal';

import { withViewAnalytics } from '../../utils/hocs/withViewAnalytics';

const DetalizationNew = ({ isPostpaid, isConvergent, isPorted, ...props }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchDetalizationPersonalData());
    dispatch(fetchRegularDetalizationReportData());
  }, []);

  return (
    <>
      <PrepaidDetalization {...props} />
      <DetalizationReportModal />
      <RegularDetalizationReportModal />
      <EmailModal />
    </>
  );
};

export default compose(
  withViewAnalytics,
)(DetalizationNew);
